import BaseLabel from "../label/BaseLabel";
import { BaseOption } from "./BaseSelect";

const ListSelect: React.FC<{
  id: string;
  className?: string;
  label?: string;
  options: BaseOption[];
  onClick: (e: any) => void;
}> = ({ id, className, label, options, onClick }) => {
  return (
    <>
      {label && <BaseLabel id={id} className={className} text={label || ""} />}
      <div className={"control list " + className}>
        {options.map((option) => (
          <option
            key={`${id}_${option.key}`}
            value={option.key}
            className="list-item"
            onClick={onClick}
          >
            {option.value}
          </option>
        ))}
      </div>
    </>
  );
};
export default ListSelect;
